module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText'),
      "back": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "slogan-wrapper"
  }, [_c('span', {
    staticClass: "slogan-text"
  }, [_vm._v(_vm._s(_vm.$t('basic.updatePwd')))])]), _vm._v(" "), _c('div', {
    staticClass: "account-form"
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPwd),
      expression: "oldPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.oldPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.oldPwd')
    },
    domProps: {
      "value": (_vm.oldPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.oldPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.oldPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.oldPwdValidate.error) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.oldPwdInvalidate')))]) : _vm._e(), _vm._v(" "), (_vm.loginResult.fail) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notExist')))]) : _vm._e(), _vm._v(" "), (_vm.oldPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPwd),
      expression: "newPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.newPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.newPwd')
    },
    domProps: {
      "value": (_vm.newPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.newPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.newPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.newPwdValidate.same) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notSame')))]) : _vm._e(), _vm._v(" "), (_vm.newPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPwd),
      expression: "confirmPwd"
    }],
    staticClass: "form-input",
    class: {
      'input-require': _vm.confirmPwdValidate.invalidate
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('basic.confirmPwd')
    },
    domProps: {
      "value": (_vm.confirmPwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.resetPwd($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPwd = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.confirmPwdValidate.emtpy) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.confirmPwdInput')))]) : _vm._e(), _vm._v(" "), (_vm.confirmPwdValidate.same) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('basic.notSameWith')))]) : _vm._e(), _vm._v(" "), (_vm.confirmPwdValidate.format) ? _c('p', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.$t('register.password_set')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-row btn-wrap"
  }, [_c('p', {
    staticClass: "text-error",
    class: {
      lang: _vm.lang === 'en' || _vm.lang === 'ru_RU'
    }
  }, [_vm._v(_vm._s(_vm.low ? _vm.$t('basic.lowPw') : ''))]), _vm._v(" "), _c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPwd
    }
  }, [_vm._v(_vm._s(_vm.$t('basic.Submit')))])])]), _vm._v(" "), _c('loading', {
    attrs: {
      "appear": _vm.processing
    }
  })], 1), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-623f25a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-623f25a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/resetPwd.vue
// module id = 162
// module chunks = 1 2